export default __webpack_public_path__ + "static/media/earth-icon.48a22e64.svg";